export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ENTERPRISE_ADMIN = 'ENTERPRISE_ADMIN',
  USER = 'USER',
  EMPLOYEE = 'EMPLOYEE',
}

export interface User {
  userId: string;
  email: string;
  name?: string;
  role: UserRole;
  companyId?: string;
  isActive: boolean;
  governanceMode?: string;
  visibility?: string;
}

export interface Company {
  companyId: string;
  name: string;
  subscriptionActive: boolean;
  tenantConfig: any;
}

export interface ApiResponse<T = any> {
  success: boolean;
  data: T;
  error?: {
    code: string;
    message: string;
    correlation_id?: string;
  };
}

export interface HealthScore {
  score: number;
  trend: 'up' | 'down' | 'stable';
  lastUpdated: string;
}

export interface MarginModel {
  currentMargin: number;
  targetMargin: number;
  variance: number;
}

export interface Contract {
  contractId: string;
  status: 'active' | 'expired' | 'pending';
  value: number;
  expiryDate: string;
}
